var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 52,
  height: 52,
  viewBox: "0 0 52 52"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u041F\\u043B\\u0435\\u0439",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-48"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-5",
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#000",
  fillOpacity: 0.4,
  stroke: "#FFF",
  strokeOpacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  id: "Triangle-2",
  fill: "#FFF",
  d: "m26.744 17.442 7.558 15.116H19.186z",
  opacity: 0.9,
  transform: "rotate(90 26.744 25)"
}))))));
export default SvgVideo;